import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiHome } from 'react-icons/fi';

const NotFoundContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #0A0A0A;
  color: white;
  text-align: center;
`;

const TopGlow = styled.div`
  position: absolute;
  top: -150px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 300px;
  background: radial-gradient(circle, rgba(0, 0, 254, 0.4) 0%, rgba(0, 0, 0, 0) 70%);
  z-index: 0;
`;

const GridBackground = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(rgba(20, 20, 20, 0.05) 1px, transparent 1px),
              linear-gradient(90deg, rgba(20, 20, 20, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
  z-index: 0;
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  max-width: 600px;
`;

const ErrorCode = styled.div`
  font-size: 120px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 24px;
  background: linear-gradient(to right, #0000fe, #6060ff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  @media (max-width: 768px) {
    font-size: 80px;
  }
`;

const ErrorTitle = styled.h1`
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 16px;
`;

const ErrorMessage = styled.p`
  font-size: 18px;
  color: #aaaaaa;
  margin-bottom: 40px;
  line-height: 1.5;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
`;

const StyledButton = styled(Link)`
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const PrimaryButton = styled(StyledButton)`
  background: linear-gradient(90deg, #0000fe, #6060ff);
  color: white;
  
  &:hover {
    box-shadow: 0 6px 15px rgba(0, 0, 254, 0.3);
  }
`;

const SecondaryButton = styled.button`
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
  }
`;

const NotFound = () => {
  return (
    <NotFoundContainer>
      <TopGlow />
      <GridBackground />
      
      <ContentWrapper>
        <ErrorCode>404</ErrorCode>
        <ErrorTitle>Page Not Found</ErrorTitle>
        <ErrorMessage>
          The page you are looking for might have been removed, had its name changed, 
          or is temporarily unavailable.
        </ErrorMessage>
        
        <ButtonsContainer>
          <SecondaryButton onClick={() => window.history.back()}>
            <FiArrowLeft />
            Go Back
          </SecondaryButton>
          <PrimaryButton to="/">
            <FiHome />
            Home Page
          </PrimaryButton>
        </ButtonsContainer>
      </ContentWrapper>
    </NotFoundContainer>
  );
};

export default NotFound;
